var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"la-error-404"},[_c('h2',{staticClass:"la-error-404__code"},[_vm._v("\n    404\n  ")]),_c('p',{staticClass:"la-error-404__message"},[_vm._v("\n    "+_vm._s(_vm.$t('pageNotFound'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }